module.exports = __webpack_public_path__ + "img/vdp_100.4bb9c61a.png";